var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_73_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1056_",
    d: "M28.6565 13.4138L26.1328 10.8901V3.22264C26.1328 2.89903 25.8705 2.6367 25.5469 2.6367H17.8794L15.4143 0.171606C15.1855 -0.0572021 14.8145 -0.0572021 14.5856 0.171606L12.1205 2.6367H4.45312C4.12951 2.6367 3.86719 2.89903 3.86719 3.22264V10.89L1.3435 13.4137C1.23363 13.5237 1.17188 13.6727 1.17188 13.8281V29.414C1.17188 29.7377 1.4342 30 1.75781 30H12.3633C12.6869 30 12.9492 29.7377 12.9492 29.414C12.9492 29.0904 12.6869 28.8281 12.3633 28.8281H3.17244L15 17.0005L26.8276 28.8281H17.6367C17.3131 28.8281 17.0508 29.0904 17.0508 29.414C17.0508 29.7377 17.3131 30 17.6367 30H28.2422C28.5658 30 28.8281 29.7377 28.8281 29.414V13.8281C28.8281 13.6727 28.7664 13.5237 28.6565 13.4138ZM27.6562 15.2427V27.9995L21.2779 21.6211L27.6562 15.2427ZM27.4136 13.8281L26.1328 15.1089V12.5474L27.4136 13.8281ZM15 1.41456L16.2221 2.6367H13.7779L15 1.41456ZM2.34375 15.2427L8.72209 21.6211L2.34375 27.9995V15.2427ZM3.86719 15.1089L2.58645 13.8281L3.86719 12.5474V15.1089ZM14.5857 15.7575L9.55078 20.7924L5.03906 16.2807V3.80858H24.9609V16.2807L20.4492 20.7924L15.4143 15.7575C15.1855 15.5287 14.8145 15.5287 14.5857 15.7575Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1085_",
    d: "M15 28.8281C14.8459 28.8281 14.6947 28.8908 14.5857 28.9998C14.4768 29.1088 14.4141 29.26 14.4141 29.4141C14.4141 29.5682 14.4768 29.7193 14.5857 29.8283C14.6947 29.9373 14.8459 30 15 30C15.1541 30 15.3053 29.9373 15.4143 29.8283C15.5232 29.7193 15.5859 29.5682 15.5859 29.4141C15.5859 29.26 15.5232 29.1088 15.4143 28.9998C15.3053 28.8908 15.1541 28.8281 15 28.8281Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1086_",
    d: "M9.70703 7.08984H20.293C20.6166 7.08984 20.8789 6.82752 20.8789 6.50391C20.8789 6.18029 20.6166 5.91797 20.293 5.91797H9.70703C9.38342 5.91797 9.12109 6.18029 9.12109 6.50391C9.12109 6.82752 9.38342 7.08984 9.70703 7.08984Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1108_",
    d: "M20.8789 9.78516C20.8789 9.46154 20.6166 9.19922 20.293 9.19922H9.70703C9.38342 9.19922 9.12109 9.46154 9.12109 9.78516C9.12109 10.1088 9.38342 10.3711 9.70703 10.3711H20.293C20.6166 10.3711 20.8789 10.1088 20.8789 9.78516Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1109_",
    d: "M18.1055 12.4805H11.8945C11.5709 12.4805 11.3086 12.7428 11.3086 13.0664C11.3086 13.39 11.5709 13.6523 11.8945 13.6523H18.1055C18.4291 13.6523 18.6914 13.39 18.6914 13.0664C18.6914 12.7428 18.4291 12.4805 18.1055 12.4805Z",
    fill: "#8f65da"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.ac819bcb98eaf939f7ef747bd10ef0ba.svg";
export { ForwardRef as ReactComponent };